module.exports = __webpack_public_path__ + "static/media/tuberia-conduit-cedula-40.2f789e7e.jpg";